import { render, staticRenderFns } from "./InstallmentDetail.vue?vue&type=template&id=e986dae8&scoped=true"
import script from "./InstallmentDetail.vue?vue&type=script&lang=js"
export * from "./InstallmentDetail.vue?vue&type=script&lang=js"
import style0 from "./InstallmentDetail.vue?vue&type=style&index=0&id=e986dae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e986dae8",
  null
  
)

export default component.exports